<template>
  <v-row class="my-5" justify="center">
    <v-col cols="12" sm="6" md="6" lg="4" xl="4" align="center">
      <v-alert
        v-model="errorMsgAlert"
        close-text="Close Alert"
        class="alert-text mb-5"
        color="error"
        dark
        dismissible
        ref="snackbarError"
      >
        {{ $t(errorMsg) }}
      </v-alert>

      <v-form ref="refundPasswordForm">
        <!-- <div placeholder="{{ 'Refund Password' | translate }}"></div> -->
        <v-text-field
          :label="$t(['Refund Password'])"
          :placeholder="$t(['Refund Password'])"
          name="Refund Password"
          type="password"
          v-model="refundPassword"
          :rules="rules.refundPassword"
          prepend-inner-icon="mdi-lock"
          persistent-placeholder
          outlined
        ></v-text-field>
      </v-form>

      <v-btn
        class="btn-text btn-multiline"
        color="primary"
        :loading="refundLoginBtn"
        x-large
        block
        translate
        @click="refundLogin()"
      >
        <span class="text-wrap">{{ $t(["Login"]) }}</span>
      </v-btn>

      <v-btn
        class="mt-3"
        style="font-size: 12px"
        text
        translate
        @click="backToHome()"
      >
        {{ $t(["Back"]) }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { Auth } from "aws-amplify";

import { useAuthenicationStore } from "../../store/authenication";

export default {
  name: "RefundLogin",
  data: () => ({
    refundPassword: "",
    refundLoginBtn: false,
    errorMsgAlert: false,
    errorMsg: "",
    rules: {
      refundPassword: [],
    },
  }),
  setup() {
    const authStore = useAuthenicationStore();

    return {
      authStore,
    };
  },
  methods: {
    setFieldValidationRules() {
      this.rules.refundPassword = [
        (v) => !!v || this.$gettext(this.$t(["Required"])),
      ];
    },
    async refundLogin() {
      await this.setFieldValidationRules();

      if (this.$refs.refundPasswordForm.validate()) {
        this.refundLoginBtn = true;

        try {
          await Auth.currentSession().then(async (data) => {
            await this.authStore
              .authenticateRefundLoginApi(
                { refundPassword: this.refundPassword },
                data.idToken.jwtToken
              )
              .then((response) => {
                // console.log(response);

                if (response.success) {
                  this.$cookies.set(
                    "tff_authenicateRefundLogin",
                    this.refundPassword,
                    "1h"
                  );

                  this.$router.replace("/refundOverview");
                  return;
                } else {
                  throw response.message;
                }
              });
          });
        } catch (error) {
          this.errorMsgAlert = true;
          this.errorMsg = error.message == undefined ? error : error.message;

          this.$nextTick(() => {
            const el = this.$el.querySelector("snackbarError");
            this.$vuetify.goTo(-5, el);

            return;
          });
        }

        this.refundLoginBtn = false;
      }
    },
    backToHome() {
      this.$router.push("/home");
    },
  },
};
</script>

<style lang="scss" scoped></style>
